import { PRODUTOS, CATEGORIAS } from './produtos';

const API = process.env.REACT_APP_BACKEND_URL;

export function mapApiProduto(p) {
  const promocional = p.precoPromocional != null;
  return {
    id: p.id,
    nome: p.nome,
    marca: p.marca || null,
    categoria: p.categoria,
    categoriaNome: p.categoriaNome || null,
    sku: p.sku || null,
    descricao: p.descricao || '',
    detalhes: p.detalhes || [],
    preco: promocional ? p.precoPromocional : p.precoVenda,
    precoDe: promocional ? p.precoVenda : null,
    parcelas: p.parcelas || null,
    imagem: (p.fotos && p.fotos[0]) || '',
    fotos: p.fotos || [],
    esgotado: p.status === 'esgotado',
    estoqueExibido: p.estoqueExibido ?? null,
  };
}

const fallbackEstatico = {
  items: PRODUTOS.map((p) => ({ ...p, fotos: [p.imagem], esgotado: false })),
  categorias: CATEGORIAS.filter((c) => c.id !== 'todos').map((c) => ({
    id: c.id,
    nome: c.nome,
    total: PRODUTOS.filter((p) => p.categoria === c.id).length,
  })),
};

export async function fetchCatalogo() {
  const resp = await fetch(`${API}/api/produtos`);
  if (!resp.ok) throw new Error('Falha ao carregar catálogo');
  const data = await resp.json();
  return { items: data.items.map(mapApiProduto), categorias: data.categorias };
}

export async function fetchProduto(id) {
  const resp = await fetch(`${API}/api/produtos/${id}`);
  if (!resp.ok) throw new Error('Produto não encontrado');
  return mapApiProduto(await resp.json());
}

export const HOME_PADRAO = {
  carrossel: { ativo: false, intervaloSeg: 6 },
  banners: [],
  secoes: [
    { id: 'destaques', ativo: true, titulo: 'Produtos em Destaque', subtitulo: 'Seleção especial da loja' },
    { id: 'ofertas', ativo: true, titulo: 'Ofertas e Promoções', subtitulo: 'Preços especiais por tempo limitado' },
    { id: 'categorias', ativo: true, titulo: '', subtitulo: '' },
    { id: 'produtos', ativo: true, titulo: 'Nossos produtos', subtitulo: '' },
  ],
  destaques: { ativo: true, limite: 8, ids: [] },
};

export async function fetchHome(previa = false) {
  if (previa) {
    const r = await fetch(`${API}/api/admin/homepage/previa`, { credentials: 'include' });
    if (r.ok) return r.json();
  }
  const resp = await fetch(`${API}/api/homepage`);
  if (!resp.ok) throw new Error('Falha ao carregar página inicial');
  return resp.json();
}

export async function fetchIdentidade() {
  const resp = await fetch(`${API}/api/identidade`);
  if (!resp.ok) throw new Error('falha');
  return resp.json();
}

export const catalogoFallback = fallbackEstatico;
